import { DrawerHeader } from '@cat-ecom/pcc-components';

type AssociatedDealerHeaderProps = {
  isModal: boolean;
  children: React.ReactNode;
};

export const AssociatedDealerHeader = ({
  isModal,
  children
}: AssociatedDealerHeaderProps) => {
  return (
    <>
      {isModal ? (
        <div>{children}</div>
      ) : (
        <DrawerHeader>{children}</DrawerHeader>
      )}
    </>
  );
};
